import React, { useState, useEffect, useRef } from "react";
import { withRouter, useHistory } from "react-router-dom";
import style from "./snappShop.module.scss";
import Button from "../Button/button"
import Skeleton from "../variantList/skeleton"
import Searchbar from "../productSearchbar/productSearchbar";
import ImportSnappVariantModal from "../importSnappVariantModal/importSnappVariantModal"
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Pagination from "../pagination/pagination";
import Progressbar from "../progressbar/progressbar"
import MobilePagination from "../mobilePagination/mobilePagination"
import SnappShopCard from "./snappShopCard/snappShopCard"
import MobileSnappShopCard from "./MobileSnappShopCard/mobileSnappShopCard"
import SnappShopFilters from "./SnappShopFilters/filters"
import SnappProSetting from "../snappShopProSetting/proSetting"
import Toast from "../Toast/Toast"
import noVariantEmptyState from '../../assets/icons/EmptyStates/variant_noactivevariant.svg'
import noChannelEmptyState from '../../assets/icons/EmptyStates/variant_nochannel.svg'
import noResultEmptyState from '../../assets/icons/EmptyStates/variant_noresult.svg'
import { GetSnappShopVariantList, SyncSnappShopVariants, GetSnappShopVendors, GetSnappShopGroupList, GetSnappShopBrandList, EdiSnappShoptVariant, CalcPriceSnappShoptVariant } from "../../actions/APIcalls"

const SnappShop = (props) => {

    const [variantList, setVariantList] = useState({
        list: [],
        variantListCount: 1000,
        variantListPageCount: 37,
        uploadShow: false,
        loading: true,
        hasChannel: false,
        totalProducts: 0,
        // syncStatus
        isSyncing: false,
        loadAmount: 0,
        product_synced_count: 0,
        product_count: 0,
        // filters
        filters: {
            // errors: [],
            groupList: [],
            brandList: [],
        }
    })
    const [editModalData, setEditModalData] = useState({
        variantData: {},
        open: false
    })
    const [toast, setToast] = useState('')
    const [locationKeys, setLocationKeys] = useState([])
    const history = useHistory()

    // handle back and forward 
    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    // Handle forward event
                    getVariants();
                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    // Handle back event
                    getVariants();
                }
            }
        })
    }, [locationKeys,])
    // end handle back and forward 

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end


    useEffect(() => {
        getChannelList()
        getFilters()
    }, [])

    const getFromUrl = (param) => {
        let url = new URLSearchParams(window.location.search);
        const defaultParams = {
            countInPage: 10,
            page: 1,
            // errors: url.get('errors') ? (url.get('errors').split("*")).map(el => el.replace('+', ' ')) : [],
            brandList: url.get('brandList') ? (url.get('brandList').split("*")).map(el => el.replace('+', ' ')) : [],
            groupList: url.get('groupList') ? (url.get('groupList').split("*")).map(el => el.replace('+', ' ')) : [],
        }
        if (url.get(param)) {
            if (url.get(param) === "true" || url.get(param) === "false") {
                return url.get(param) === "true" ? true : false;
            } else {
                return (param == 'errors' || param == 'brandList' || param == 'groupList') ? defaultParams[param] : url.get(param)
            }
        } else {
            return defaultParams[param];
        }
    }

    const handleMobilePageNumber = (number) => {
        setToUrl(number, 'page')
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getVariants();
    }

    const loadingSync = useRef()

    const determineLoadingAmount = async () => {
        let tmp = variantList
        let vendors = await GetSnappShopVendors()
        if (typeof vendors !== "undefined" && typeof vendors.data !== "undefined" && vendors.data.data && vendors.data.data.length > 0) {
            tmp.hasChannel = true
            tmp.product_count = 0
            tmp.product_synced_count = 0
            vendors.data.data.map(el => {
                if (el.is_syncing) {
                    tmp.isSyncing = true
                    tmp.product_count += el.product_count
                    tmp.product_synced_count += el.product_synced_count
                    tmp.loadAmount = (tmp.product_synced_count / tmp.product_count) * 100
                } else {
                    tmp.isSyncing = false
                    tmp.product_count += el.product_count
                    tmp.product_synced_count += el.product_synced_count
                    tmp.loadAmount = 100
                }
            })
        } else {
            tmp.hasChannel = false
        }
        setVariantList({ ...tmp })

        if ((variantList.product_synced_count == variantList.product_count) || variantList.loadAmount == 100) {
            clearInterval(loadingSync.current);
            getVariants()
        }
    }

    const getFilters = async () => {
        let tmp = variantList
        // let errors = (await GetSnappShopErrorList()).data?.error_list || []
        let groupList = (await GetSnappShopGroupList()).data?.groupList || []
        let brandList = (await GetSnappShopBrandList()).data?.brandList || []
        // tmp.filters.errors = errors.map(el => { let elObject = { name: el.name, value: el.value, checked: false }; if (getFromUrl('errors').includes(el.value)) { elObject.checked = true }; return elObject })
        tmp.filters.groupList = groupList.map(el => { let elObject = { name: el, checked: false }; if (getFromUrl('groupList').includes(el.name)) { elObject.checked = true }; return elObject })
        tmp.filters.brandList = brandList.map(el => { let elObject = { name: el, checked: false }; if (getFromUrl('brandList').includes(el.name)) { elObject.checked = true }; return elObject })
        setVariantList({ ...tmp })
    }

    const handleChangeFilter = (tag, selected) => {
        let selectedArray = []
        let tmp = variantList
        tmp.filters[tag].map((el, index) => {
            if (el.name == selected.name) {
                tmp.filters[tag][index].checked = !selected.checked
            }
            if (tmp.filters[tag][index].checked) {
                selectedArray.push(tag == 'errors' ? el.value : el.name)
            }
        })
        if (selectedArray.length > 0) {
            setToUrl(selectedArray, tag)
        } else {
            deleteFromUrl(tag)
        }
        setVariantList({ ...tmp })
    }

    const checkUrl = () => {
        let url = new URLSearchParams(window.location.search);
        let hasQueries = false
        Object.keys(variantList.filters).map(el => {
            if (url.get(el)) {
                hasQueries = true
            }
        })
        return hasQueries
    }

    const deleteFromUrl = async (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push(window.location.pathname + "?" + url.toString());
        let tmp = variantList
        tmp.filters[param].map((el, index) => {
            tmp.filters[param][index].checked = false
        })
        setVariantList({ ...tmp })
        getVariants()
    }

    const handleDeleteAll = () => {
        let url = new URLSearchParams(window.location.search);
        let filters = Object.keys(variantList.filters)
        let tmp = variantList
        filters.forEach(el => {
            url.delete(el);
            tmp.filters[el].map((filterElement, filterIndex) => {
                tmp.filters[el][filterIndex].checked = false
            })
        })
        setVariantList({ ...tmp })
        props.history.push(window.location.pathname + "?" + url.toString());
        getVariants()
    }

    const handleDropdownSearch = (tag, query) => {
        let tmp = variantList
        tmp.filters[tag] = query;
        setVariantList({ ...tmp })
    }

    const getChannelList = async () => {
        await determineLoadingAmount()
        if ((variantList.product_synced_count == variantList.product_count) || variantList.loadAmount == 100) {
            getVariants()
            return () => clearInterval(loadingSync.current);
        } else {
            loadingSync.current = setInterval(async () => {
                await determineLoadingAmount()
            }, 10000);
            return () => clearInterval(loadingSync.current);
        }
    }

    const syncVariants = async () => {
        let tmp = variantList
        tmp.loading = true
        setVariantList({ ...tmp })
        let res = await SyncSnappShopVariants()
        if (res && res.data && res.data.success) {
            await getChannelList()
        }
        tmp.loading = false
        setVariantList({ ...tmp })
    }

    const emptyStateRenderer = () => {
        // when there's no channel
        if (!variantList.hasChannel) {
            return <div className={style.empty}>
                <div className={style.image}>
                    <img src={noChannelEmptyState} />
                </div>
                <p>اینجا همه‌ی تنوع‌هایی که دارید رو می‌بینید و می‌تونید با تکمیل اطلاعات، ربات رو براشون فعال کنید</p>
                <p className={style.boldText}>برای شروع لیست کالاها رو از اسنپ‌شاپ دریافت کنید و بعد از تکمیل اطلاعات آپلود کنید</p>
                <Button
                    type="solid"
                    label={"اتصال به پنل اسنپ‌شاپ"}
                    onclick={() => props.history.push('/channels')}
                />
            </div>
        }
        // when there's no variants in channel;
        if (variantList.list.length == 0 && variantList.totalProducts == 0) {
            return <div className={style.empty}>
                <div className={style.image}>
                    <img src={noVariantEmptyState} />
                </div>
                <p>اینجا همه‌ی تنوع‌هایی که دارید رو می‌بینید و می‌تونید با تکمیل اطلاعات، ربات رو براشون فعال کنید</p>
                <p className={style.boldText}>برای شروع لیست کالاها رو به‌روز رسانی کنید</p>
                <Button type="solid"
                    label={"به‌روز رسانی تنوع‌ها ازاسنپ‌شاپ"}
                    onclick={syncVariants} />
            </div>
        }
        // when there's no result for the search
        if (variantList.list.length == 0 && variantList.totalProducts > 0) {
            return <div className={style.empty}>
                <div className={style.image}>
                    <img src={noResultEmptyState} />
                </div>
                <p className={style.boldText}>!نتیجه‌ای یافت نشد</p>
                <p className={style.mediumText}>لطفا عبارت دیگری جستجو کنید</p>
                <p className={style.grayText}>درصورت اطمینان از وجود این تنوع در اسنپ‌شاپ تنوع‌ها را به‌روز رسانی کنید</p>
                <div className={style.addPannelButtonWrapper}>
                    <Button type='solid' label='بازگشت' onclick={() => props.history.goBack()} />
                    <Button type='noBorder' label='به‌روز رسانی تنوع‌ها از اسنپ‌شاپ' onclick={() => syncVariants} />
                </div>
            </div>
        }
    }

    const getVariants = async () => {
        setVariantList({ ...variantList, loading: true, isSyncing: false, uploadShow: false })
        let reqObject = {
            countInPage: getFromUrl("countInPage") ? getFromUrl("countInPage") : 10,
            page: getFromUrl("page") ? getFromUrl("page") : 1,
            q: getFromUrl("search") ? getFromUrl("search") : '',
            productGroup: getFromUrl("groupList") ? getFromUrl("groupList") : [],
            brand: getFromUrl("brandList") ? getFromUrl("brandList") : [],
            // errors: getFromUrl("errors") ? getFromUrl("errors") : []
        }
        let res = await GetSnappShopVariantList(reqObject)
        let tmpLogList = variantList
        if (res && res.data) {
            tmpLogList.list = res.data.data
            tmpLogList.variantListCount = res.data.variationCount
            tmpLogList.variantListPageCount = res.data.totalPages
            tmpLogList.totalProducts = res.data.details.total
        } else {
            tmpLogList.error = 'داده‌ای برای نمایش وجود ندارد'
        }
        tmpLogList.loading = false
        tmpLogList.isSyncing = false
        tmpLogList.uploadShow = false
        setVariantList({ ...tmpLogList })
    }

    const openToast = error => {
        setToast(error)
    }

    const editData = async (data) => {
        let res = await EdiSnappShoptVariant(data)
        getVariants()
        return res;
    }

    const calculatePrice = async (data) => {
        let res = await CalcPriceSnappShoptVariant(data)
        return res;
    }

    const openProSetting = sentData => {
        let tmpModalData = editModalData
        tmpModalData.variantData = sentData
        tmpModalData.open = true
        setEditModalData({ ...tmpModalData })
    }

    if (variantList.isSyncing) {
        return <div className={style.wrapper}>
            <div className={style.empty}>
                <div className={style.image}>
                    <img src={noVariantEmptyState} />
                </div>
                <p>.کاربر عزیز، در حال حاضر شما هیچ کالایی در ربات موبیشا ندارید</p>
                <p className={style.boldText}>. لیست کالاهای شما درحال بروز رسانی از اسنپ‌شاپ میباشد </p>
                <div className={style.progressbarwrapperDown}>
                    <Progressbar width={parseInt(variantList.loadAmount)} />
                    <div className={style.textRow}>
                        <p className={style.text}>
                            {toPersianNumber(variantList.product_synced_count)}
                            {" "} کالا از{" "}
                            {toPersianNumber(variantList.product_count)}
                            {" "}کالا دریافت شد.{" "}
                        </p></div>
                </div>
            </div>
        </div>
    } else if (variantList.loading) {
        return <Skeleton />
    }
    else {
        return (
            <div className={style.wrapper}>
                <ImportSnappVariantModal
                    show={variantList.uploadShow}
                    closeModal={() => {
                        setVariantList({ ...variantList, uploadShow: false });
                        getVariants();
                    }}
                />
                <SnappProSetting
                    open={editModalData.open}
                    data={editModalData.variantData}
                    parentClose={() => setEditModalData({ ...editModalData, open: false })}
                    handleCalculate={calculatePrice}
                    handleEdit={editData}
                    toast={openToast}
                />
                <Toast tag="errorToast" value={toast} text={toast} parentClose={() => setToast('')} />
                {variantList.list && variantList.list.length > 0 ?
                    <>
                        <div className={style.header}>
                            <h1 className={style.title}>تنوع‌های اسنپ‌شاپ</h1>
                            <div className={style.buttonsWrapper}>
                                <div className={style.settingButton}>
                                    <Button
                                        disabled={false}
                                        tag="n1"
                                        type="outline"
                                        label="تکمیل اطلاعات با اکسل"
                                        onclick={() => { setVariantList({ ...variantList, uploadShow: true }) }}
                                    />
                                </div>
                                <div className={style.settingButton}>
                                    <Button
                                        disabled={false}
                                        tag="n1"
                                        type="solid"
                                        label="به‌روزرسانی تنوع‌ها از اسنپ‌شاپ"
                                        onclick={() => syncVariants()}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={style.searchbarWrapper}>
                            <Searchbar
                                placeholder={"عنوان یا کد کالا یا کد تنوع"}
                                value={getFromUrl('search') ? getFromUrl('search') : ''}
                                searchValue={(value) => setToUrl((value ? value : ''), 'search')}
                            />
                        </div>

                        <div className={style.filterWrapper}>
                            <SnappShopFilters
                                filters={variantList.filters}
                                handleChangeFilters={handleChangeFilter}
                                handleDropdownSearch={handleDropdownSearch}
                                deleteFromUrl={deleteFromUrl}
                                handleDeleteAll={handleDeleteAll}
                                checkUrl={checkUrl}
                            />
                        </div>

                        <div className={style.paginationWrapper}>
                            <div className={style.pagination}>
                                <div className={style.Dropdown}>
                                    <Pagination
                                        tag="page"
                                        currentPage={parseInt(getFromUrl("page"))}
                                        pageCount={variantList.variantListPageCount}
                                        setPage={setToUrl}
                                    />

                                    <div className={style.gap20}></div>

                                    <TinyDropdown
                                        placeholder={10}
                                        dropdownList={["10", "25", "50", "75", "100"]}
                                        selected={selected => {
                                            setToUrl(selected, 'countInPage')
                                        }}
                                        selectedItem={getFromUrl('countInPage')}
                                    />
                                    <div className={style.label}>تعداد نمایش در صفحه</div>
                                    <div className={style.verticalLine}></div>
                                    <div
                                        className={style.variantCount}>{typeof variantList.variantListCount !== 'undefined' ? toPersianNumber(variantList.variantListCount) + " نتیجه" : ""}</div>
                                </div>
                            </div>
                        </div>

                        <div className={style.desktopTable}>
                            <div className={style.hiddenListShadow}></div>
                            <div className={style.logListWrapper}>
                                <div
                                    className={offset > 480 ? style.listHeaderFixed : style.listHeader}
                                    style={offset > 480 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 480 ? { width: 'calc(100% - 280px)' } : null)}
                                >
                                    <div className={style.listHeaderItem278}>مشخصات کالا</div>
                                    <div className={style.listHeaderItem42}>وضعیت فروش</div>
                                    <div className={style.listHeaderItem92}><span>قیمت خرید</span><span className={style.unit}>(تومان)</span></div>
                                    <div className={style.listHeaderItem347}>
                                        <div>
                                            <p>حداقل حاشیه سود<span>(تومان)</span></p>
                                            <div className={style.divider}></div>
                                            <p>حداکثر حاشیه سود<span>(تومان)</span></p>
                                        </div>
                                    </div>
                                    <div className={style.listHeaderFlexItem32noMargin}></div>
                                    <div className={style.listHeaderFlexItem32noMargin}></div>
                                </div>
                                <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                                <div className={style.listWrapper}>
                                    {variantList.list ? variantList.list.map((listItem, index) => <SnappShopCard
                                        key={index}
                                        data={listItem}
                                        editData={editData}
                                        toast={openToast}
                                        openProSetting={openProSetting}
                                    />) : null}
                                </div>
                            </div>
                        </div>

                        <div className={style.mobileTable}>
                            {variantList.list ? variantList.list.map((listItem, index) => <MobileSnappShopCard key={index} data={listItem} />) : null}
                            <MobilePagination
                                tag="page"
                                currentPage={parseInt(getFromUrl("page"))}
                                pageCount={variantList.variantListPageCount}
                                setPage={handleMobilePageNumber}
                            />
                        </div>

                        <div className={style.paginationTwo}>
                            <Pagination
                                tag="page"
                                currentPage={parseInt(getFromUrl("page"))}
                                pageCount={variantList.variantListPageCount}
                                setPage={setToUrl}
                            />
                        </div>
                    </>
                    :
                    emptyStateRenderer()
                }
            </div>
        )
    }
}
export default withRouter(SnappShop);